import { Logo, Typography } from '@corabank/arco'
import { useDocs } from '@Store'

import * as Styled from './styled'

const Header = (): JSX.Element => {
  const { businessName } = useDocs()

  return (
    <Styled.Header>
      <Logo size="small" className="logo-cora" />

      <Styled.Content>
        <Typography variant="title3" weight="bold">
          Empresa - {businessName}
        </Typography>
      </Styled.Content>
    </Styled.Header>
  )
}

export { Header }
